export default class Media {
    static load(contentId) {
        // console.log(`Load media for id: ${contentId}`);
    }
}